import { Box, styled } from "@mui/material";

export const StyledInvoicePage = styled(Box)(({ theme }) => ({
  width: "100%",
  paddingLeft: "2rem",
  maxHeight: "100vh",
  ".header": {
    position: "relative",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    gridArea: "1 / 1 / 2 / 4",
    paddingBottom: "1rem",
    h1: {
      color: theme.color.dark,
    },
    ".backbtn": {
      position: "absolute",
      right: "1rem",
      display: "flex",
      gap: "1rem",
    },
  },
  ".content": {
    display: "flex",
    justifyContent: "space-evenly",
    ".infoWrapper": {
      ".info": {
        width: "35rem",
        margin: "auto",
        padding: "1rem",
        boxSizing: "border-box",
        border: `5px solid ${theme.color.main}`,
        borderRadius: "10px",
        ".text": {
          fontWeight: "bold",
          color: theme.color.dark,
        },
        ".row": {
          display: "flex",
          width: "100%",
          justifyContent: "space-between",
          alignItems: "center",
          ".column": {
            width: "50%",
          },
          button: {
            height: "min-content",
            padding: ".25rem",
            boxSizing: "border-box",
            margin: "0",
            minWidth: "min-content",
          },
        },
      },
    },
    ".file": {
      width: "55rem",
      height: "90vh",
      borderRadius: "10px",
    },
  },
  [`@media screen and (max-width: ${theme.breakpoints.values.wide}px)`]: {
    height: "100vh",
    ".content": {
    display: "flex",
    justifyContent: "space-evenly",
    ".infoWrapper": {
      ".info": {
        width: "25rem",
        padding: "0",
        ".row": {
          ".column": {
            width: "100%",
            display: "flex",
            alignItems: "center",
            flexDirection: "column",
            textAlign: "center"
          },
        },
      },
    },
    ".file": {
      width: "40rem",
    },
  },
  },
}));
